var jade = require("/opt/atlassian/pipelines/agent/build/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("see --> exploreAnalyticsPanelsWrapperNg1.jade");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/explore/exploreBreakdownModalContentWrapperNg1.jade
 ** module id = 718
 ** module chunks = 0
 **/